(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-collection-sidebar"] && !Shopify.designMode) return;
  try {
    document.addEventListener("click", function(e){
  const toggle = e.target.closest(".filter-toggle");
  if(!toggle) return;

  const group = toggle.closest(".filter-group");
  group.classList.toggle("is-open");
});
  } catch(e) { console.error(e); }
})();

})();
